// reducer.js

import {
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  RESET_CHANGE_PASSWORD,
} from './ChangePasswordType';

const initialState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const changePasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        successMessage: null,
        errorMessage: null,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
        errorMessage: null,
      };
    case CHANGE_PASSWORD_FAILURE:
      return { ...state, loading: false, errorMessage: action.payload };

    case RESET_CHANGE_PASSWORD:
  return {
        ...state,
        loading: false,
        successMessage: null,
        errorMessage: null,
      };

    default:
      return state;
  }
};

export default changePasswordReducer;
